import React from 'react';

// Component
import TableFare from './TableFare';
import HorizontalMinFareBar from './HorizontalMinFareBar';
import { Box } from '@mui/system';

function Section01(props: any) {
  const {
    days, selectedDate, handleSelectDate, isFetching, errorStatistics, flightData, handleSelectTrip, isDesktop,
  } = props;
  return (
    <Box sx={{
      background: '#FFFFFF',
      boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
      borderRadius: '12px',
      overflow: 'hidden',
    }}
    >
      <HorizontalMinFareBar
        isDesktop={isDesktop}
        days={days}
        selectedDate={selectedDate}
        onSelectDate={handleSelectDate}
        isFetching={isFetching}
        errorStatistics={errorStatistics}
      />
      <TableFare
        isDesktop={isDesktop}
        isCompanyCityCity
        selectedDate={selectedDate}
        flightData={flightData}
        onSelectTrip={handleSelectTrip}
      />
    </Box>
  );
}

export default React.memo(Section01);
